import { render, staticRenderFns } from "./FormFisikNotFoundReadonly.vue?vue&type=template&id=a93c1174&"
import script from "./FormFisikNotFoundReadonly.vue?vue&type=script&lang=js&"
export * from "./FormFisikNotFoundReadonly.vue?vue&type=script&lang=js&"
import style0 from "./FormFisikNotFoundReadonly.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports